import { Box, Button, Stack, Typography } from '@mui/material';
import { Loader } from 'src/components';
import { SETTINGS_SECTION_ROW_PADDING } from 'src/components/SettingsSection';

export const SectionLoadingRow = () => (
  <Box sx={SETTINGS_SECTION_ROW_PADDING}>
    <Loader />
  </Box>
);

export const SectionErrorRow = ({
  message,
  onRetry,
}: {
  message: string;
  onRetry: () => void;
}) => (
  <Stack sx={SETTINGS_SECTION_ROW_PADDING} spacing={2} alignItems="flex-start" role="alert">
    <Typography variant="body2" color="error.main">
      {message}
    </Typography>
    <Button variant="outlined" onClick={onRetry}>
      Retry
    </Button>
  </Stack>
);
